/**
 * @fileoverview POST handler for the "/engagement/:app_group_id/structural_template/canvas_template/:template_id/canvas" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { engagementCanvasFromCanvasTemplateCacheKeys } from "./constants";
import type { PostEngagementCanvasFromCanvasTemplateProps, CanvasFromCanvasTemplateResult } from "./types";

export const postCanvasFromCanvasTemplate = reactQueryMutationAdapter(
  engagementCanvasFromCanvasTemplateCacheKeys,
  (props: PostEngagementCanvasFromCanvasTemplateProps): Promise<CanvasFromCanvasTemplateResult> => {
    return fetch(
      `/engagement/${props.appGroupId}/structural_template/canvas_template/${props.templateId}/canvas`,
      "POST",
      props,
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
